// Centralised content & imagery for the DIMIRXSON demo

export const NAV_LINKS = [
  { label: 'Exhibitions', href: '/exhibitions' },
  { label: 'Artists', href: '/artists' },
  { label: 'About', href: '/about' },
  { label: 'Contact', href: '/contact' },
  { label: 'Private Events', href: '/private-events' },
  { label: 'Art Advisory', href: '/art-advisory' },
  { label: 'Journal', href: '/journal' },
];

export const HERO = {
  wordmark: 'DIMIRXSON',
  subtitle: 'Lit From Within',
  intro: 'Cluj-Napoca',
  image:
    '/images/image5.png',
  imageAlt: 'Cinematic contemporary gallery interior',
};

export const INTRO = {
  eyebrow: 'Curatorial Statement — 001',
  headline: 'Art as space.\nSpace as memory.',
  copy: [
    'DIMIRXSON moves between exhibition, archive and architectural enquiry — a platform for artists, writers and spatial practitioners working across the contemporary moment.',
    'Through commissions, publications and long-form research, we trace how materiality, identity and place continue to reshape the way images are made, held and remembered.',
  ],
};

export const EXHIBITIONS = [
  {
    id: 'lit-from-within',
    number: '01',
    title: 'Lit From Within',
    year: '2026',
    location: 'Cluj-Napoca',
    status: 'On view',
    dates: '06.05.2026 — 30.07.2026',
    description:
      'LIT FROM WITHIN brings together six painting practices shaped by inner intensity, visual clarity, and the emergence of form from within. The exhibition proposes painting as a medium through which an essential force becomes perceptible while continuing to resonate beyond the image.',
    curator: 'Tiziana Cellino',
    image:
      '/images/lit-from-within/lit-from-within.webp',
    imageFit: 'contain',
    imageAspect: '16 / 9',
    galleryLayout: 'lit-from-within',
    gallery: [
      '/images/lit-from-within/lfw3.webp',
      '/images/lit-from-within/lfw4.webp',
      '/images/lit-from-within/lfw5.webp',
      '/images/lit-from-within/lfw2.webp',
      '/images/lit-from-within/lfw1.webp',
      '/images/lit-from-within/lfw6.webp',
    ],
  },
  {
    id: 'upcoming',
    number: '02',
    title: 'Soon to be announced',
    year: '2026',
    location: 'Cluj-Napoca',
    status: 'Upcoming',
    dates: 'Soon to be announced',
    description: 'Soon to be announced.',
    image: '/images/image6.png',
  },
  {
    id: 'exhibit-1',
    number: '03',
    title: 'Exhibit 01',
    year: '2026',
    location: 'Cluj-Napoca',
    status: 'Archive',
    dates: '07.01.2026 — 01.05.2026',
    description:
      'DIMIRXSON Gallery opens to the public with Exhibit 01, the first exhibition curated together with The Cureators. The show presents a diverse selection of artists exploring identity, transformation, resilience, memory, and the emotional landscapes of contemporary life.',
    curator: 'The Cureators',
    image:
      '/images/exhibit 01/exhibit01.webp',
    imageFit: 'contain',
    galleryLayout: 'opening',
    gallery: [
      '/images/exhibit 01/CSG-2020.webp',
      '/images/exhibit 01/CSG-1366.webp',
      '/images/exhibit 01/CSG-1470.webp',
      '/images/exhibit 01/CSG-1489.webp',
    ],
  },
];

export const VISUAL_BREAK = {
  caption:
    'Installation view — “The Architecture of Silence”, Hall A, Cluj-Napoca, October 2025. Photograph by Andrei Mareș.',
  image:
    '/images/image4.png',
};

export const PHILOSOPHY = {
  eyebrow: 'Practice',
  heading: 'A reading\nroom for the\ncontemporary.',
  paragraphs: [
    'DIMIRXSON is conceived as an editorial and curatorial structure — a place where exhibitions, conversations and printed matter share the same address.',
    'We work with artists at the threshold of disciplines: architects who paint, writers who build, photographers who archive. Each project unfolds as a long-form essay on materiality, identity and the contemporary city.',
    'The platform is independent, slow by design, and deliberately international — a quiet correspondence between studios in Cluj-Napoca, Athens, Lisbon and Berlin.',
  ],
};

export const WORKS = [
  {
    title: 'Void Form I',
    medium: 'Plaster, pigmented wax',
    year: '2024',
    image:
      '/images/image1.png',
    span: 'tall',
  },
  {
    title: 'Chromatic Field',
    medium: 'Oil and graphite on linen',
    year: '2025',
    image:
      '/images/image2.png',
    span: 'short',
  },
  {
    title: 'Structural Memory',
    medium: 'Bronze, ambient light',
    year: '2025',
    image:
      '/images/image3.png',
    span: 'short',
  },
  {
    title: 'Linear Progression',
    medium: 'Ink and gesso on paper',
    year: '2023',
    image:
      '/images/image7.png',
    span: 'tall',
  },
  {
    title: 'Interior, Reversed',
    medium: 'Archival pigment print',
    year: '2024',
    image:
      '/images/image5.png',
    span: 'tall',
  },
  {
    title: 'Temporal Shift',
    medium: 'Silver gelatin print',
    year: '2026',
    image:
      '/images/image6.png',
    span: 'short',
  },
];

export const ARTISTS = [
  {
    id: 'iulia-voinea',
    number: '01',
    name: 'Iulia Voinea',
    discipline: 'Sculpture / Material research',
    city: 'Cluj-Napoca',
    status: 'Represented',
    image: '/images/image1.png',
    statement:
      'Voinea works with plaster, wax and inherited industrial fragments, tracing how gesture remains visible inside hardened matter.',
    works: ['Void Form I', 'Structural Memory'],
  },
  {
    id: 'andrei-mares',
    number: '02',
    name: 'Andrei Mares',
    discipline: 'Photography / Architecture',
    city: 'Berlin',
    status: 'Collaborator',
    image: '/images/image5.png',
    statement:
      'Mares documents quiet interiors, civic thresholds and the residue of exhibition spaces after public use.',
    works: ['Interior, Reversed', 'Temporal Shift'],
  },
  {
    id: 'mara-petrescu',
    number: '03',
    name: 'Mara Petrescu',
    discipline: 'Painting / Surface',
    city: 'Lisbon',
    status: 'Guest artist',
    image: '/images/image2.png',
    statement:
      'Petrescu builds chromatic fields from graphite, oil and repeated erasure, approaching painting as an architectural surface.',
    works: ['Chromatic Field'],
  },
  {
    id: 'daniel-sava',
    number: '04',
    name: 'Daniel Sava',
    discipline: 'Installation / Text',
    city: 'Athens',
    status: 'Research',
    image: '/images/image7.png',
    statement:
      'Sava stages language as a physical structure, placing text, light and found material inside temporary rooms.',
    works: ['Linear Progression'],
  },
];

export const EXHIBITED_ARTIST_NAMES = [
  'Silvia Radu', 'Victor Ciato', 'Ioana Iacob', 'Laurențiu Zbîrcea', 'Anca Brânzaș',
  'Tiziana Cellino', 'Nicolas Leș', 'Alexandra Neacșu', 'Sebastian Nasta',
  'Trick Patrick', 'Paul Covaci', 'Amirou Diallo', 'Norbert Ștefan', 'Robert Pusok',
];

export const EXHIBITED_ARTIST_DETAILS = {
  'Silvia Radu':
    'Silvia Radu (1935–2025) stands among the defining figures of Romanian post war art. Working across sculpture, painting, and ceramics, she developed a practice shaped by spirituality, inner resistance, and a sustained engagement with the human condition.\n\nMarked by symbolic clarity and quiet force, her work often responded to the psychological and ideological pressures of the communist period, transforming fragility, faith, and endurance into enduring visual form.',
  'Victor Ciato':
    'Victor Ciato (1938–2021) occupies a singular position within Romanian post war abstraction. Moving away from the dominant aesthetics of Socialist Realism, he developed a distinctive painterly language that evolved from gestural abstraction toward a more rigorous geometric vocabulary.\n\nHis Momentul 0 works marked a decisive turn toward non figurative painting, establishing abstraction as both a formal pursuit and a space of artistic autonomy.',
  'Anca Brânzaș':
    'Anca Brânzaș (b. 1986) develops a painterly language shaped by memory, displacement, and an enduring attachment to Romanian folklore, mythology, and lived experience. For Brânzaș, painting becomes a space of return, a means of negotiating distance, intimacy, and belonging.\n\nMoving between symbolic imagery and emotional immediacy, her practice approaches painting as both encounter and transformation, suspended between longing, devotion, and the search for an inner sense of wholeness.',
  'Ioana Iacob':
    'Ioana Iacob (b. 1987) examines intimacy, solitude, and emotional vulnerability through quietly charged figurative painting. Drawing from the domestic realm, her works often observe private moments that unfold unnoticed, suspended between presence and detachment.\n\nMarked by psychological precision and a subtle voyeuristic gaze, Iacob’s paintings capture the emotional atmosphere of a generation navigating loneliness, intimacy, and increasing distance in an ever more mediated world.',
  'Laurențiu Zbîrcea':
    'Laurențiu Zbîrcea (b. 2000) develops a visual language shaped by instinct, memory, and lived experience. Often drawing from autobiographical fragments, his paintings construct emotionally dense spaces in which the figure oscillates between presence and dissolution.\n\nMoving between intimacy and unease, his practice approaches painting as a site of psychological negotiation rather than representation.',
  'Tiziana Cellino':
    'Tiziana Cellino (b. 1996) works through abstraction to examine the threshold between movement and stillness. Built through gesture, rhythm, and accumulation, her paintings seek the suspended moment in which energy begins to assume form, before image settles into recognition.\n\nRather than describing the world, Tiziana approaches painting as a site of tension, where structure emerges from instability and perception remains unresolved.',
  'Nicolas Leș':
    'Nicolas Leș works at the intersection of the anatomical and the conceptual, sculptures that move between inner tension and outward force, built from stone, metal, resin, and glass. His practice draws on the history of form while refusing to stay inside it.',
  'Alexandra Neacșu':
    'Alexandra Neacșu builds a practice around what connects us: to each other, to our cultural heritage, to the materials we inherit. Moving between the domestic and the philosophical, her textile works explore burnout, vulnerability, and the quiet metamorphosis of matter into meaning.',
  'Trick Patrick':
    'Trick Patrick builds surfaces that resist resolution: dense, confrontational, and physically present. His paintings function as acts of opposition: to visual order, to comfort, to the idea that art should explain itself. The canvas becomes a field of tension between structure and dissolution, lucidity and the loss of self.',
  'Paul Covaci':
    'In Paul Covaci\'s practice, the surreal, the political, and the playful coexist, and sharpen each other. Mythology, pop culture, Jungian psychology, and the organic world converge into a visual language that is as fantastical as it is acute.',
  'Norbert Ștefan':
    'Berlin-based Norbert Ștefan blends digital and analog techniques to create paintings guided by chance and material reaction. Using methods like decalcomania, his layered compositions evoke natural and cosmic phenomena, dreamlike, temporal, and visually unpredictable. His practice is built on improvisation and the ongoing dialogue between mind and matter.',
  'Sebastian Nasta':
    'In Sebastian Nasta\'s paintings, the human figure holds its ground. Working in oil on canvas, he captures the moments when pressure - emotional, historical, environmental - becomes visible in the face and body. A practice built at the boundary between personal vulnerability and collective crisis, where simply remaining upright becomes an act in itself.',
  'Amirou Diallo':
    'Amirou Diallo works in acrylic on canvas, painting suspended moments charged with tension and quiet narrative. His practice moves between portraiture, allegory, and visual philosophy, figures caught between worlds, gazes that look back, silences that speak. His work asks the viewer to slow down, look closer, and sit with what they find.',
  'Robert Pusok':
    'Robert Pusock works at the intersection of sound and image, using vibration as a drawing tool, making visible what the ear can only hear. His practice is built on the principle that sound carries geometry: every tone produces a structure, every frequency a form. The result is a body of work that sits between scientific phenomenon and visual poetry, where the unseen world reveals itself as pattern, harmony, and line.',
};

export const EXHIBITED_ARTIST_DETAILS_RO = {
  'Silvia Radu':
    'Silvia Radu (1935–2025) se numără printre figurile definitorii ale artei românești postbelice. Lucrând în sculptură, pictură și ceramică, a dezvoltat o practică artistică modelată de spiritualitate, rezistență interioară și o reflecție constantă asupra condiției umane.\n\nMarcată de o claritate simbolică și de o forță discretă, opera sa a răspuns adesea presiunilor psihologice și ideologice ale perioadei comuniste, transformând fragilitatea, credința și rezistența în forme vizuale de o durabilitate remarcabilă.',
  'Victor Ciato':
    'Victor Ciato (1938–2021) ocupă o poziție aparte în cadrul abstracției românești postbelice. Îndepărtându-se de estetica dominantă a realismului socialist, el a dezvoltat un limbaj pictural distinct, care a evoluat de la abstracția gestuală către un vocabular geometric tot mai riguros.\n\nSeria Momentul 0 a marcat un moment decisiv în orientarea sa către pictura nonfigurativă, consacrând abstracția atât ca demers formal, cât și ca spațiu al autonomiei artistice.',
  'Anca Brânzaș':
    'Anca Brânzaș (n. 1986) dezvoltă un limbaj pictural modelat de memorie, dezrădăcinare și de o legătură profundă cu folclorul românesc, mitologia și experiența trăită. Pentru Brânzaș, pictura devine un spațiu al întoarcerii, un mod de a negocia distanța, intimitatea și apartenența.\n\nOscilând între imagistica simbolică și imediatul emoțional, practica sa tratează pictura ca pe un loc al întâlnirii și al transformării, suspendată între dor, devoțiune și căutarea unui sentiment lăuntric al întregului.',
  'Ioana Iacob':
    'Ioana Iacob (n. 1987) explorează intimitatea, singurătatea și vulnerabilitatea emoțională printr-o pictură figurativă încărcată de o tensiune subtilă. Pornind din spațiul domestic, lucrările sale surprind adesea momente private care se desfășoară neobservate, suspendate între prezență și detașare.\n\nMarcate de precizie psihologică și de o privire discret voyeuristică, picturile sale surprind atmosfera emoțională a unei generații care navighează singurătatea, intimitatea și distanțarea într-o lume tot mai mediatizată.',
  'Laurențiu Zbîrcea':
    'Laurențiu Zbîrcea (n. 2000) dezvoltă un limbaj vizual modelat de instinct, memorie și experiență personală. Inspirându-se adesea din fragmente autobiografice, picturile sale construiesc spații încărcate emoțional, în care figura oscilează între prezență și dizolvare.\n\nMișcându-se între intimitate și neliniște, practica sa tratează pictura ca pe un spațiu al negocierii psihologice, mai degrabă decât al reprezentării.',
  'Tiziana Cellino':
    'Tiziana Cellino (n. 1996) lucrează prin abstracție pentru a explora pragul dintre mișcare și imobilitate. Construite prin gest, ritm și acumulare, picturile sale caută acel moment suspendat în care energia începe să capete formă, înainte ca imaginea să se fixeze în recunoaștere.\n\nMai degrabă decât să descrie lumea, Tiziana înțelege pictura ca pe un spațiu al tensiunii, unde structura se naște din instabilitate, iar percepția rămâne deliberat deschisă.',
  'Nicolas Leș':
    'Nicolas Leș lucrează la intersecția dintre anatomic și conceptual, realizând sculpturi care oscilează între tensiunea interioară și forța exterioară, construite din piatră, metal, rășină și sticlă. Practica sa dialoghează cu istoria formei, refuzând însă să rămână încadrată în limitele acesteia.',
  'Alexandra Neacșu':
    'Ceea ce ne conectează unii la alții, cultura din care venim și materialele pe care le moștenim stau la baza practicii artistice ale Alexandrei Neacșu. Lucrările ei textile se mișcă între domestic și filosofic, explorând epuizarea, vulnerabilitatea și metamorfoza discretă a materiei în sens.',
  'Trick Patrick':
    'Trick Patrick lucrează în acrilic impasto, construind suprafețe dense, confruntaționale și profund materiale, care refuză orice rezolvare facilă. Picturile sale funcționează ca acte de opoziție: față de ordinea vizuală, față de lectura imediată și față de ideea că arta ar trebui să ofere confort în loc să provoace. Pânza devine un câmp de tensiune între structură și dizolvare, luciditate și pierderea sinelui.',
  'Paul Covaci':
    'Suprarealul, politicul și ludiculul nu se exclud în practica lui Paul Covaci, se hrănesc unul din celălalt. Mitologie, cultură pop, psihologie jungiană și forme organice ale naturii, reunite într-un limbaj vizual deopotrivă fantastic și acut.',
  'Norbert Ștefan':
    'Stabilit la Berlin, Norbert Ștefan îmbină tehnici digitale și analogice pentru a crea picturi ghidate de hazard și de reacția materiei. Folosind procedee precum decalcomania, el construiește compoziții stratificate care evocă fenomene naturale și cosmice, onirice, efemere și imprevizibile din punct de vedere vizual. Practica sa se întemeiază pe improvizație și pe dialogul continuu dintre minte și materie.',
  'Sebastian Nasta':
    'În pictura lui Sebastian Nasta, figura umană rezistă. Lucrând în ulei pe pânză, Nasta surprinde momentele în care presiunea - emoțională, istorică, de mediu - devine vizibilă pe chip și în corp. O practică construită la granița dintre vulnerabilitatea personală și criza colectivă, în care a rămâne în picioare devine în sine un act.',
  'Amirou Diallo':
    'Amirou Diallo lucrează în acrilic pe pânză, construind momente suspendate, încărcate de tensiune și de o narațiune discretă. Practica sa se mișcă între portret, alegorie și reflecție vizuală, cu figuri aflate între lumi, priviri care răspund privitorului și tăceri care comunică. Lucrările sale invită privitorul să încetinească, să privească mai atent și să rămână în dialog cu ceea ce descoperă.',
  'Robert Pusok':
    'Robert Pusock lucrează la intersecția dintre sunet și imagine, folosind vibrația ca instrument de desen pentru a face vizibil ceea ce poate fi perceput doar prin auz. Practica sa se întemeiază pe principiul că sunetul poartă în sine geometrie: fiecare ton generează o structură, fiecare frecvență dă naștere unei forme. Rezultatul este un corpus de lucrări situat la granița dintre fenomenul științific și poezia vizuală, unde lumea invizibilă se revelează prin tipar, armonie și linie.',
};

const ARTIST_WORK_FILES = {
  'Alexandra Neacșu': [
    ['/artisti-gallery/alexandra-neacsu/01.jpg', 'Neacsu Alexandra - Apparition, mixed media (cotton), 76x96x5cm din 2025.png'],
    ['/artisti-gallery/alexandra-neacsu/02.jpg', 'Neacsu Alexandra - Burning out, mixed media(cotton), 97x193cm din 2023.png'],
    ['/artisti-gallery/alexandra-neacsu/03.jpg', 'Neacsu Alexandra - Exposure, mixed media (cotton), 200x200x2cm din 2023.png'],
    ['/artisti-gallery/alexandra-neacsu/04.jpg', 'Neacsu Alexandra - mixed media (cotton), 97x193cm din 2022.png'],
  ],
  'Amirou Diallo': [
    ['/artisti-gallery/amirou-diallo/01.jpg', 'Amirou Diallo 3.png'],
    ['/artisti-gallery/amirou-diallo/02.jpg', 'Amirou Diallo 4.png'],
    ['/artisti-gallery/amirou-diallo/03.jpg', 'Amirou Diallo 5.png'],
    ['/artisti-gallery/amirou-diallo/04.jpg', 'Amirou Diallo 7.png'],
  ],
  'Anca Brânzaș': [
    ['/artisti-gallery/anca-branzas/01.jpg', 'Branzas Anca - Dansatoarea Soarelui, 94,5x145cm din 2022.png'],
    ['/artisti-gallery/anca-branzas/02.jpg', 'Branzas Anca - Sirena orientala se inchina in fata printului, poil on canvas, 144x120cm din 2021-2026.png'],
    ['/artisti-gallery/anca-branzas/03.jpg', 'Branzas Anca - Sufletul Copacilor, 142x105cm din 2022.png'],
    ['/artisti-gallery/anca-branzas/04.jpg', 'Branzas Anca - Tacerea care desparte, oil on canvas, 40x29,5cm din 2024.png'],
    ['/artisti-gallery/anca-branzas/05.jpg', 'Branzas Anca - Templul Florilor, 53,5x64,5cm din 2025.png'],
    ['/artisti-gallery/anca-branzas/06.jpg', 'Branzas Anca - Vreau sa fumez, oil on canvas, 21,5x26,5cm din 2022.png'],
  ],
  'Tiziana Cellino': [
    ['/artisti-gallery/cellino-tiziana/01.jpg', 'Cellino Tiziana -  Red on Blue, oil on canvas,24,5x30cm din 2024.png'],
    ['/artisti-gallery/cellino-tiziana/02.jpg', 'Cellino Tiziana -  Untitled,oil on canvas, 28x30cm din 2026.png'],
    ['/artisti-gallery/cellino-tiziana/03.jpg', 'Cellino Tiziana - Underwater Love, oil on canvas, 194x204cm din 2019.png'],
    ['/artisti-gallery/cellino-tiziana/04.jpg', 'Cellino Tiziana - Untitled, oil on canvas,150x150cm din 2025.png'],
    ['/artisti-gallery/cellino-tiziana/05.jpg', 'Cellino Tiziana - Untitled,oil and acrylic on canvas, 100x100cm din 2019.png'],
  ],
  'Ioana Iacob': [
    ['/artisti-gallery/ioana-iacob/01.jpg', 'Iacob Ioana - Messy, oil on paper, 66x45cm din 2026.png'],
    ['/artisti-gallery/ioana-iacob/02.jpg', 'Iacob Ioana - My Little Baby Girl, oil on upcycled synthetic canvas, 54,5x44,5cm din 2026.png'],
    ['/artisti-gallery/ioana-iacob/03.jpg', 'Iacob Ioana - Ofelia, oil on canvas, 30x28cm din 2026.png'],
    ['/artisti-gallery/ioana-iacob/04.jpg', 'Iacob Ioana - She leaves, oil on canvas, 90x70cm din 2026.png'],
    ['/artisti-gallery/ioana-iacob/05.jpg', 'Iacob Ioana - The air before it breaks,oil on canvas, 150x200cm din 2025.png'],
    ['/artisti-gallery/ioana-iacob/06.jpg', 'Iacob Ioana - We need dish soap, oil on canvas, 43x52cm din 2026.png'],
  ],
  'Laurențiu Zbîrcea': [
    ['/artisti-gallery/laurentiu-zbircea/01.jpg', 'Zbircea Laurentiu - But Not Today, mixed media on canvas,207x193cm din 2022-2026.png'],
    ['/artisti-gallery/laurentiu-zbircea/02.jpg', 'Zbircea Laurentiu - Reflection, mixed media on canvas, 70x79cm din 2022-2026.png'],
    ['/artisti-gallery/laurentiu-zbircea/03.jpg', 'Zbircea Laurentiu - Untitled, mixed media on canvas, 150x222cm din 2022-2026.png'],
    ['/artisti-gallery/laurentiu-zbircea/04.jpg', 'Zbircea Laurentiu - Untitled, mixed media on canvas, 94x72cm din 2022-2026.png'],
    ['/artisti-gallery/laurentiu-zbircea/05.jpg', 'Zbircea Laurentiu 0 Testing, mixed media on canvas, 150x100cm din 2022-2026.png'],
  ],
  'Nicolas Leș': [
    ['/artisti-gallery/nicolas-les/01.jpg', 'Les Nicolae - Contrapposto, mixed media, 50x60x130cm din 2019.png'],
    ['/artisti-gallery/nicolas-les/02.jpg', 'Les Nicolae - Metaform, mixed media (epoxy resin, paint, prefabricated components), 65x50x125cm din 2019.png'],
    ['/artisti-gallery/nicolas-les/03.jpg', 'Les Nicolae - Panoptikum 2, concretesculpture,25x35x50cm din 2019.png'],
    ['/artisti-gallery/nicolas-les/04.jpg', 'Les Nicolae - Panoptikum, mixed media, 30x40x47cm din 2019.png'],
  ],
  'Norbert Ștefan': [
    ['/artisti-gallery/norbert-stefan/01.jpg', 'Norbert Setfan - Untitled, 63x93cm, oil on stainless steel 2025.png'],
    ['/artisti-gallery/norbert-stefan/02.jpg', 'Norbert Stefan - Dark Knight of the Soul,140x90cm, oil on canvas 2025.png'],
    ['/artisti-gallery/norbert-stefan/03.jpg', 'Norbert Stefan - Sleepwalker, 60x100cm, oil on canvas 2026.png'],
    ['/artisti-gallery/norbert-stefan/04.jpg', 'Norbert Stefan - tehnica dimensiuni 2025.png'],
  ],
  'Paul Covaci': [
    ['/artisti-gallery/paul-covaci/01.jpg', 'Covaci Paul - Amphibious Chair, wood sculpture, 76x65x132cm 2023-2025.png'],
    ['/artisti-gallery/paul-covaci/02.jpg', 'Covaci Paul - fara detalii 2.png'],
    ['/artisti-gallery/paul-covaci/03.jpg', 'Covaci Paul - fara detalii 3.png'],
    ['/artisti-gallery/paul-covaci/04.jpg', 'Covaci Paul - fara detalii 4.png'],
    ['/artisti-gallery/paul-covaci/05.jpg', 'Covaci Paul - fara detalii 5.png'],
    ['/artisti-gallery/paul-covaci/06.jpg', 'Covaci Paul - fara detalii 6.png'],
    ['/artisti-gallery/paul-covaci/07.jpg', 'Covaci Paul - fara detalii.png'],
    ['/artisti-gallery/paul-covaci/08.jpg', 'Covaci Paul - I think there’s something between us, oil on canvas, 180x 140cm 2023-2025.png'],
    ['/artisti-gallery/paul-covaci/09.jpg', 'Covaci Paul - Neo Gothic Chairr, wood sculpture, 46x54x144cm 2023-2025.png'],
  ],
  'Robert Pusok': [
    ['/artisti-gallery/robert-pusock/01.jpg', 'Pusok Robert - 1519,28Hz, monotipie, 83x83cm 2025.png'],
    ['/artisti-gallery/robert-pusock/02.jpg', 'Pusok Robert - 417,26Hz, monotipie, 83x83cm 2025.png'],
    ['/artisti-gallery/robert-pusock/03.jpg', 'Pusok Robert - 475Hz, monotipie, 83x83cm 2025.png'],
    ['/artisti-gallery/robert-pusock/04.jpg', 'Pusok Robert - 503,68Hz, monotipie, 83x83cm 2025.png'],
    ['/artisti-gallery/robert-pusock/05.jpg', 'Pusok Robert - 537,62Hz, monotipie, 83x83cm 2025.png'],
    ['/artisti-gallery/robert-pusock/06.jpg', 'Pusok Robert - 858,81Hz, monotipie, 83x83cm 2025.png'],
  ],
  'Sebastian Nasta': [
    ['/artisti-gallery/sebastian-nasta/01.jpg', 'Nasta Sebastian - Big Paintingtest.png'],
    ['/artisti-gallery/sebastian-nasta/02.jpg', 'Nasta Sebastian.png'],
  ],
  'Silvia Radu': [
    ['/artisti-gallery/silvia-radu/01.jpg', 'Radu Silvia - 23.png'],
  ],
  'Trick Patrick': [
    ['/artisti-gallery/trick-patrick/01.jpg', 'Trcik Patrick - fara detalii.png'],
    ['/artisti-gallery/trick-patrick/02.jpg', 'Trick Patrick - The Void,  acrylic impasto on canvas, 70x100cm 2025.png'],
    ['/artisti-gallery/trick-patrick/03.jpg', 'Trick Patrick - Thecut, acrylic impasto on canvas,70x100cm 2025.png'],
  ],
  'Victor Ciato': [
    ['/artisti-gallery/victor-ciato/01.jpg', 'Ciato Victor 9.png'],
  ],
};

const parseWorkFile = ([src, filename], index) => {
  const clean = filename.replace(/\.(png|jpe?g|webp)$/i, '').replace(/\s+/g, ' ').trim();
  const afterArtist = clean.includes(' - ') ? clean.split(' - ').slice(1).join(' - ').trim() : clean;
  const dinMatch = afterArtist.match(/\s+din\s+(.+)$/i);
  const withoutDin = dinMatch ? afterArtist.slice(0, dinMatch.index).trim() : afterArtist;
  const yearMatch = withoutDin.match(/\s+(\d{4}(?:-\d{4})?)$/);
  const year = dinMatch ? dinMatch[1].trim() : yearMatch ? yearMatch[1] : '';
  const withoutYear = yearMatch && !dinMatch ? withoutDin.slice(0, yearMatch.index).trim().replace(/,$/, '') : withoutDin;
  const parts = withoutYear.split(',').map((part) => part.trim()).filter(Boolean);
  const title = parts[0] || `Work ${String(index + 1).padStart(2, '0')}`;
  const details = parts.slice(1).join(', ');

  return {
    title,
    details,
    year,
    src,
    originalFilename: filename,
  };
};

export const artistSlug = (name) =>
  name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const getExhibitedArtists = (language = 'en') => {
  const details = language === 'ro' ? EXHIBITED_ARTIST_DETAILS_RO : EXHIBITED_ARTIST_DETAILS;

  return EXHIBITED_ARTIST_NAMES.map((name, index) => ({
    id: artistSlug(name),
    number: String(index + 1).padStart(2, '0'),
    name,
    city: '',
    discipline: '',
    status: language === 'ro' ? 'Expus' : 'Exhibited',
    statement: details[name] || '',
    works: (ARTIST_WORK_FILES[name] || []).map(parseWorkFile),
    image: ARTIST_WORK_FILES[name]?.[0]?.[0] || `/images/image${(index % 10) + 1}.png`,
  }));
};

export const findExhibitedArtist = (id, language = 'en') =>
  getExhibitedArtists(language).find((artist) => artist.id === id);

export const JOURNAL = [
  {
    number: 'N° 014',
    category: 'Essay',
    date: 'November 2025',
    title: 'The Architecture of Silence',
    excerpt:
      'On rooms that refuse to perform — and the slow politics of an exhibition that asks the visitor to wait.',
    image:
      '/images/image6.png',
  },
  {
    number: 'N° 013',
    category: 'Studio Visit',
    date: 'October 2025',
    title: 'Material, Memory and Form',
    excerpt:
      'A conversation with sculptor Iulia Voinea on inherited materials, family archives and the texture of slow making.',
    image:
      '/images/image8.png',
  },
  {
    number: 'N° 012',
    category: 'Field Notes',
    date: 'September 2025',
    title: 'Curating Space Beyond the White Cube',
    excerpt:
      'Notes from three temporary exhibitions held inside disused civic interiors across Eastern Europe.',
    image:
      '/images/image9.png',
  },
];

export const FOOTER = {
  brand: 'DIMIRXSON',
  tagline: 'Contemporary Culture & Exhibition Platform',
  address: ['Str. Călărașilor 1', 'Cluj-Napoca, Romania'],
  contact: ['hello@dimirxson.art', '+40 745 460 705'],
  socials: [
    { label: 'Instagram', href: 'https://www.instagram.com/dimirandson/' },
    { label: 'Newsletter', href: '#' },
  ],
};


export const findExhibition = (id) => EXHIBITIONS.find((e) => e.id === id);
export const exhibitionNeighbours = (id) => {
  const idx = EXHIBITIONS.findIndex((e) => e.id === id);
  if (idx === -1) return { prev: null, next: null };
  return {
    prev: idx > 0 ? EXHIBITIONS[idx - 1] : null,
    next: idx < EXHIBITIONS.length - 1 ? EXHIBITIONS[idx + 1] : null,
  };
};
